module.exports = __webpack_public_path__ + "static/media/fixed-instagram.7b4296a1.png";